import { useDataSubmit } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props) {
  let submit = useDataSubmit({
    context: 'global',
    viewPath: props.viewPath,
  })

  return function onSubmit({ value, args }) {
    submit({
      type: 'tabs/add',
      tab: {
        id: 'Tasks',
        type: 'Tasks',
        name: 'Tasks',
        viewPath: '/App/Account/Content/Tasks',
        selected: {
          filters: {},
          has_changes: false,
          task_overlay: {
            open: true,
            task_id: args.value.task_id,
            show_board: true,
          },
        },
      },
    })

    if (typeof props.onSubmit === 'function') {
      props.onSubmit()
    }

    return true
  }
}
